import { Box, Paper, Skeleton } from '@mui/material';

function DemandMetricGroupSkeleton({ metricCount }) {
  return (
    <Paper
      elevation={0}
      className="sas-metric-skeleton"
      sx={{
        border: '1px solid',
        borderColor: 'divider',
      }}>
      <Skeleton
        variant="circular"
        width={26}
        height={26}
        className="sas-metric-skeleton-icon"
      />

      <Box className="sas-metric-skeleton-content">
        <Skeleton
          variant="text"
          width={76}
          height={22}
          className="sas-metric-skeleton-title"
        />

        <Box
          className="sas-metric-skeleton-grid"
          style={{ '--metric-count': metricCount }}>
          {Array.from({ length: metricCount }).map((_, index) => (
            <Box
              key={index}
              className={`sas-metric-skeleton-cell${index > 0 ? ' sas-metric-skeleton-cell--separated' : ''}`}
              sx={
                index > 0
                  ? {
                      borderLeftColor: 'divider',
                    }
                  : undefined
              }>
              <Skeleton
                variant="text"
                width={36}
                height={34}
              />
              <Skeleton
                variant="text"
                width={64}
                height={16}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Paper>
  );
}

export default DemandMetricGroupSkeleton;
